export interface IPageState {
  loading: boolean;
}

export enum ActionTypes {
  UPDATE_LOADING_STATUS = 'UPDATE_LOADING_STATUS',
  CREATE_POLITICA_CONTA_DIGITAL = 'CREATE_POLITICA_CONTA_DIGITAL'
}

export interface IAction {
  type: ActionTypes;
  payload?: any;
}
